import React from 'react';
import ClientsTable from './ClientsTable';
import Paper from '../common/layout/Paper';

export default function ClientsListScreen() {
	return (
		<Paper gradientBorder>
			<ClientsTable />
		</Paper>
	);
}
